// components
import { Box } from '@interstate/components/Box';
import { Typography } from '@interstate/components/Typography';

type DrivetrainDescriptionProps = {
    driveLine: string;
};

export const DrivetrainDescription = ({ driveLine }: DrivetrainDescriptionProps) => {
    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            <Typography variant="body-md" color="sem.color.on-surface.muted" tag="span">
                Drivetrain Desc:
            </Typography>
            <Typography variant="body-md" tag="span">
                {driveLine || '—'}
            </Typography>
        </Box>
    );
};
